import requets from '@/utils/request'

export function login (email) {
  return requets({
    url: '/auth?email=' + email,
    method: 'POST'
  })
}

export function google (idToken) {
  return requets({
    url: '/auth/google?idToken=' + idToken,
    method: 'POST'
  })
}

export function kodlaDogrulama (telNo, kod) {
  let data = {
    TelNo: telNo,
    Kod: kod
  }
  return requets({
    url: '/auth/kod',
    method: 'post',
    data
  })
}

export function kayit (data) {
  return requets({
    url: '/auth/kayit',
    method: 'post',
    data
  })
}

export function hocaKayit (data) {
  return requets({
    url: '/auth/hoca-kayit',
    method: 'post',
    data
  })
}

export function kodYolla (email, gmailmi = false) {
  return requets({
    url: '/auth/kod?email=' + email + '&gmailMi=' + gmailmi,
    method: 'POST'
  })
}

export function giris (email, kod) {
  let data = {
    eMail: email,
    kod: kod
  }
  return requets({
    url: '/auth/giris',
    method: 'post',
    data
  })
}

export function versionKontrol () {
  return requets({
    url: '/auth/version',
    method: 'GET'
  })
}
